module.exports = __webpack_public_path__ + "static/img/374534397.e18aa1d9.png";